import { mediaQueries } from "../constants/mediaQueries";

const Breakpoints = (function () {
  var className = "breakpoints";
  var domElem = document.querySelector(".".concat(className));
  var mediaQueryLists = {};
  var matches = {};
  var mediaQueryKeys = [
    "xxs-max",
    "xs-only",
    "xs-max",
    "sm-only",
    "sm-min",
    "sm-max",
    "md-max",
    "md-min",
    "md-only",
    "lg-min",
    "animation-medium",
  ];

  function _init() {
    if (!domElem) throw "Breakpoints: not found element .".concat(className);
    mediaQueryKeys.forEach(function (key) {
      var mediaQueryVal = mediaQueries[key];

      if (mediaQueryVal) {
        var mq = (mediaQueryLists[key] = window.matchMedia(mediaQueryVal));
        matches[key] = mq.matches;

        _setMod(key, mq.matches);

        mq.addEventListener
          ? mq.addEventListener("change", _onMatchMediaChange)
          : mq.addListener(_onMatchMediaChange);
      }
    });
  }
  /**
   * @param {String} modName
   * @param {Boolean} modVal
   */

  function _setMod(modName, modVal) {
    domElem.classList[modVal ? "add" : "remove"](
      "".concat(className, "_").concat(modName)
    );
  }

  function _onMatchMediaChange() {
    matches = mediaQueryKeys.reduce(function (acc, key) {
      acc[key] = !!(mediaQueryLists[key] || {}).matches;

      _setMod(key, acc[key]);

      return acc;
    }, {});
    var event = new CustomEvent("mediaChange", {
      detail: {
        matches: matches,
      },
    });
    domElem.dispatchEvent(event);
  }

  return {
    domElem: domElem,
    getMatches: function getMatches() {
      return matches;
    },
    init: _init,
  };
})();

Breakpoints.init();

export { Breakpoints };
